import { ApiError } from '../../api/client.js';

export function problem(e) {
  if (e?.code === 'offline') return 'No connection. Bookings can only be changed online.';
  if (e instanceof ApiError) return e.message;
  return 'Something went wrong. Try again.';
}
